// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"556aab60","239":"3bb087ee","455":"4b465cfc","832":"f7738508","977":"63c29c85"}[chunkId] + ".chunk.js";
};